<template>
  <VContent>
      <VContainer fill-height>
          <VLayout
                  style="{max-width:500px;}"
                  align-content-center
                  mx-auto
                  wrap
          >
              <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
                  <BaseCard class="my-3">
                      <VCardTitle class="title font-weight-light">
                          Change Password
                      </VCardTitle>


                      <VCardText>
                          <UserName/>
                          <Code/>
                          <VTextField
                               v-model="newPassword"
                               label="New Password"
                               name="newPassword"
                               outlined
                               :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                               :type="show ? 'text' : 'password'"
                               hint="At least 8 characters, must have a number and an uppercase letter"
                               counter
                               @click:append="show = !show"
                          />
                          <BaseBtn block large @click="change" :loading="loading">change</BaseBtn>
                      </VCardText>

                      <VCardActions>
                          <BaseBtn style="text-transform: none;" text to="/auth/signup">
                              Sign Up
                          </BaseBtn>
                          <VSpacer/>
                          <BaseBtn style="text-transform: none;" text to="/auth/forgotpassword">
                              Forgot Password ?
                          </BaseBtn>

                      </VCardActions>

                  </BaseCard>
              </VFlex>
          </VLayout>
      </VContainer>
  </VContent>
</template>

<script>
  import {
    mapActions,
  } from 'vuex'
  import BaseBtn from "../../components/BaseBtn";
  export default {
    name: 'EnterCodeReset',
    components: {
      BaseBtn,
      UserName: () => import('@/views/auth/UserName'),
      Code: () => import('@/views/auth/Code')
    },
    data: () => ({
      model: 0,
      newPassword:'',
      show:false,
      loading:false
    }),
    mounted () {
      //let l = this.$store.getters['cognito/isLoggedIn'];
    },
    computed:{

    },
    methods:{
      ...mapActions('cognito', ['changePassword']),
      ...mapActions(['openPost']),
      async change(){
        let em = this;
        em.loading=true
        let uname = this.$store.state.username;
        if(!uname.includes('@'))uname = '+1'+uname
        this.changePassword({
          username:uname,
          code:this.$store.state.confirmationcode,
          newPassword:this.newPassword
        }).then(res=>{
          window.localStorage.setItem('qhnt',this.newPassword)
          em.loading=false;
          em.$store.commit('setSnackbar',{
            type: 'success',
            msg: 'Password Reset',
            timeout:6000
          });
          em.$router.push('/auth/signin?redirect=confirmed')
        }).catch(e=>{
          console.log(e)
          em.loading=false;
          em.$store.commit('setSnackbar',{
            type: 'warning',
            msg: e.message,
            timeout:6000
          })
        })
      }
    }
  }
</script>
